import React from 'react';
import PropTypes from 'prop-types';
import RangeSelector from './range-selector/range-selector';
import overrideRange, { arrayToRange, getItems, rangeToArray } from './range-util';
import rangeType from './range-type';
import * as styles from './allhomes-range-selector.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var areRangesEqual = function areRangesEqual() {
  var range1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var range2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (range1.min || 0) === (range2.min || 0) && (range1.max || 0) === (range2.max || 0);
};
var AllhomesRangeSelector = _ref => {
  var name = _ref.name,
    max = _ref.max,
    selectedRange = _ref.selectedRange,
    onChange = _ref.onChange;
  var handleChange = array => {
    var newSelectedRange = arrayToRange(overrideRange(rangeToArray(selectedRange, max), array), max);
    if (!areRangesEqual(selectedRange, newSelectedRange)) {
      onChange(newSelectedRange);
    }
  };
  var items = getItems(max);
  return ___EmotionJSX("div", null, ___EmotionJSX("div", {
    css: styles.label
  }, name), ___EmotionJSX(RangeSelector, {
    rangeName: name,
    selectedRange: rangeToArray(selectedRange, max),
    defaultSelectedRange: rangeToArray(selectedRange, max),
    items: items,
    onChange: handleChange
  }));
};
AllhomesRangeSelector.propTypes = {
  name: PropTypes.string.isRequired,
  max: PropTypes.number.isRequired,
  selectedRange: rangeType,
  onChange: PropTypes.func
};
AllhomesRangeSelector.defaultProps = {
  onChange: () => {},
  selectedRange: {}
};
export default AllhomesRangeSelector;